/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum IdentityTypes {
    /**
     * This is a customer contactperson.
     */
    PublicUser = 10,
    ContactPerson = 20,
    /**
     * This is an regular employee from JKS.
     */
    DEKOUser = 30,
    /**
     * This identity is used by background applications.
     */
    Application = 40,
}
